import React from "react";

const ModalFirmaData = ({datos}) => {
    return (<div className="firmaContenidoDatos">
        <h5>Datos personales</h5>
        <div className="letraChica">
        <div className="row">
            <div className="col-sm-6">Seccional {datos.seccional}</div>
            <div className="col-sm-6">Número de trámite: {datos.nrotramite}</div>
        </div>
        <div className="row">
            <div className="col-sm-6">Nombre: {datos.nombreapellido}</div>
            <div className="col-sm-6">Domicilio: {datos.domicilio} 
            &nbsp; {datos.cp} &nbsp; {datos.localidad} &nbsp; {datos.provincia}</div>

        </div>
        <div className="row">
            <div className="col-sm-6">
                Fecha de nacimiento : {datos.fechanac} {datos.sexo}
            </div>
            <div className="col-sm-6">
                 Nacionalidad: {datos.nacionalidad}
            </div>
            </div>
        
        <div className="row">
            <div className="col-sm-6">
                Email {datos.email}
            </div>
            <div className="col-sm-6">
                Telefonos: {datos.tel} / {datos.cel}
            </div>
        </div>
        </div>
        <h5>Datos laborales</h5>
        <div className="letraChica">
            <div className="row">
                <div className="col-sm-6"> CUIT {datos.cuit}</div>
                <div className="col-sm-6">Fecha Alta {datos.fechaalta}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">{datos.razonsocial}</div>
                <div className="col-sm-6">Categoría: {datos.categorialaboral}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Domicilio: {datos.direccionlaboral},&nbsp; {datos.localidadlaboral},&nbsp;{datos.provincialaboral}</div>
                <div className="col-sm-6">Telefono: {datos.telefonolaboral}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Email: {datos.emaillaboral}</div>
                <div className="col-sm-6">Página Web Laboral: {datos.paginaweblaboral}</div>
            </div>
        </div>

        <h5>Familiares a cargo</h5>
        <div className="letraChica">
            {(datos.f1apellidonombre=="" || datos.f1apellidonombre==undefined)?"":<>
            <div className="row">
                <div className="col-sm-6"> 1: {datos.f1apellidonombre}</div>
                <div className="col-sm-6"> {datos.f1cuil}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Parentesco {datos.f1parentesco}</div>
                <div className="col-sm-6">Edad: {datos.f1edad}</div>
            </div>
            <div className="row">&nbsp;</div>
            </>}
            {(datos.f2apellidonombre=="" || datos.f2apellidonombre==undefined)?"":<>
            <div className="row">
                <div className="col-sm-6"> 2: {datos.f2apellidonombre}</div>
                <div className="col-sm-6"> {datos.f2cuil}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Parentesco {datos.f2parentesco}</div>
                <div className="col-sm-6">Edad: {datos.f2edad}</div>
            </div>
            <div className="row">&nbsp;</div>
            </>}
            {(datos.f3apellidonombre=="" || datos.f3apellidonombre==undefined)?"":<>
            <div className="row">
                <div className="col-sm-6"> 3: {datos.f3apellidonombre}</div>
                <div className="col-sm-6"> {datos.f3cuil}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Parentesco {datos.f3parentesco}</div>
                <div className="col-sm-6">Edad: {datos.f3edad}</div>
            </div>
            <div className="row">&nbsp;</div>
            </>}
            {(datos.f4apellidonombre=="" || datos.f4apellidonombre==undefined)?"":<>
            <div className="row">
                <div className="col-sm-6"> 3: {datos.f4apellidonombre}</div>
                <div className="col-sm-6"> {datos.f4cuil}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Parentesco {datos.f4parentesco}</div>
                <div className="col-sm-6">Edad: {datos.f4edad}</div>
            </div>
            <div className="row">&nbsp;</div>
            </>}
            {(datos.f4apellidonombre=="" || datos.f5apellidonombre==undefined)?"":<>
            <div className="row">
                <div className="col-sm-6"> 3: {datos.f5apellidonombre}</div>
                <div className="col-sm-6"> {datos.f5cuil}</div>
            </div>
            <div className="row">
                <div className="col-sm-6">Parentesco {datos.f5parentesco}</div>
                <div className="col-sm-6">Edad: {datos.f5edad}</div>
            </div>
            <div className="row">&nbsp;</div>
            </>}
            
        </div>
        
        </div>
    );

}

export default ModalFirmaData;